<template>
  <section>
    <br>
    <p class="p-style">
      Step 2: Check-Out
    </p>
    <v-card
      class="card-style"
      color="#ECEFF1"
      :style="getBgStyle"
    >
      <v-card-text>
        <v-form>
          <div>
            <v-card
              class="user-card"
              light
            >
              <p class="user-content">
                Check-Out Location:- <font
                  v-if="locationName.site_name !== undefined"
                  class="font-my-style"
                >
                  {{ locationName.site_name }}
                </font>
                <font v-else>
                  N/A
                </font>
              </p>
              <p class="user-content">
                Work Clock:-
                <check-in-clock style="color:#FF3700; font-size:16px;" />
              </p>
            </v-card>
          </div>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="#37474F"
            @click="cancel()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="#FF3700"
            @click="checkOut()"
          >
            Check Out
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card-text>
    </v-card>
    <br>
    <centre-spinner
      :loading="loading"
    />
  </section>
</template>

<script>
import spinner from 'src/views/components/SpinnerCentre';
import Constants from 'src/constants';
import moment from 'moment';
import CheckInClock from '../../Checkin/CheckInClock.vue';

export default {
  name: 'StaffCheckOut',
  components: {
    'centre-spinner': spinner,
    'check-in-clock': CheckInClock,
  },
  data: () => ({
    loading: false,
    cardBgImg: require('@/assets/img/cardBg.png'),
  }),
  computed: {
    getBgStyle () {
      return `background-image: linear-gradient(rgba(255,255,255,.6), rgba(255,255,255,.6)), url(${this.cardBgImg});`;
    },
    activeCheckInDetails () {
      return this.$store.getters['swiftuser/getActiveCheckInDetails'];
    },
    locationName () {
      return this.$store.getters['swiftuser/getLocationName'];
    },
    checkoutType () {
      return this.$store.getters['swiftuser/getCheckoutType'];
    },
    manualCheckoutReason () {
      return this.$store.getters['swiftuser/getManualCheckoutReason'];
    },
  },
  methods: {
    checkOut () {
     this.loading = true;
      this.$store.dispatch('swiftuser/checkOutUser', {
        checkOutTime: {
          checkout_time: moment.utc().format(),
          type: this.checkoutType,
          manual_checkout_reason: this.manualCheckoutReason,
        },
        checkInId: this.activeCheckInDetails.id,
      }).then(response => {
        this.loading = false;
        this.$store.dispatch('alert/onAlert', {
          message: 'Check-Out completed successfully.',
          type: Constants.ALERT_TYPE_SUCCESS,
        });
        localStorage.removeItem('checkInTime');
        localStorage.removeItem('checkIn');
        this.$emit('checkout-completed');
      }).catch(errors => {
        this.loading = false;
      });
    },
    cancel () {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'HomePage' });
      }, 2000);
    },
  },
};
</script>
<style scoped>
.p-style {
  margin-left: 10px;
  color: #37474F;
  font-weight: bold;
  font-family: 'Times New Roman', Times, serif;
  font-size: 18px;
}
.card-style {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  padding-top: 10px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.user-content {
  font-size: 16px;
  font-weight: bold;
  color: #546E7A;
  margin-left: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
  font-family:'Times New Roman', Times, serif;
}
.font-my-style {
  font-weight: bold;
  font-size: 16px;
  color: #37474F;
  font-family:'Times New Roman', Times, serif;
}
.user-card {
  border-left: 3px solid #546E7A !important;
  border-bottom: 3px solid #546E7A !important;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-top: 20px;
  margin-bottom: 30px;
}
</style>
